import { render, staticRenderFns } from "./SociosPersonaEditar.vue?vue&type=template&id=63f70884&"
import script from "./SociosPersonaEditar.vue?vue&type=script&lang=js&"
export * from "./SociosPersonaEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports